import Swiper, { Navigation } from "swiper";
import "swiper/swiper-bundle.css";

Swiper.use([Navigation]);

const SideSlider = function(settings) {
	"use strict";

	const _self = this;
	const _settings = {};

	Object.assign(_settings, settings);

	function cacheDom() {
		_settings.$el = document.querySelector(_settings.el);
		_settings.$indicator = document.querySelector(_settings.currentNumber);
	}

	function pad(number, length) {
		var str = "" + number;
		while (str.length < length) {
			str = "0" + str;
		}

		return str;
	}

	function initSwiper() {
		_settings.slider = new Swiper(_settings.el, {
			speed: 400,
			loopedSlides: 9,
			loop: true,
			slidesPerView: "auto",
			spaceBetween: 32,
			slidesOffsetBefore: 32,
			autoHeight: false,
			preventClicks: false,
			preventClicksPropagation: false,
			slideActiveClass: _settings.slideActiveClass,
			navigation: {
				nextEl: _settings.nextEl,
				prevEl: _settings.prevEl
			},
			breakpoints: {
				681: {
					slidesOffsetBefore: 60,
					spaceBetween: 24
				}
			}
		});
	}

	function init() {
		cacheDom();
		initSwiper();

		return _self;
	}

	return init();
};

export { SideSlider };
